export const GA_CONFIG_ID = 'G-86KHGCS4KL';

export function initGa() {
    var dataLayer = window['dataLayer'] = window['dataLayer'] || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', GA_CONFIG_ID);

    (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "j4t8aicp0r");
}
